import React, { useContext, useState } from 'react';
import LogoutHeader from '../../components/Headers/LogoutHeader';
import LoginHeader from '../../components/Headers/LoginHeader';
import LogoutFooter from '../../components/Footers/LogoutFooter';
import LoginFooter from '../../components/Footers/LoginFooter';
import Inbox from '../../components/Inbox';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const InboxPage = () => {
  const { isLoggedIn, user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const [trigger, setTrigger] = useState(false);

  return (
    <>  
      {isLoggedIn ? (role === "admin" ? <AdminHeader trigger={trigger} /> : <LoginHeader trigger={trigger} />) : <LogoutHeader />}
      <main>
        <Inbox 
          setTrigger={setTrigger}
          trigger={trigger}
        />
      </main>
      {isLoggedIn ? <LoginFooter /> : <LogoutFooter />}
    </>
  );
}

export default InboxPage;